export default __webpack_public_path__ + "static/media/480_dummy2016-cafe01-de.e318d8bf.png";